export enum BpmnExpressionFields {
    Incoterm = "Incoterm"
}